import buildUrl from "../helpers/buildUrl";
import buildUrlLocation from "../helpers/buildUrlLocation";
import fetchClient from "../helpers/fetchClient";
import isEmpty from "../helpers/isEmpty";
import NewsModel from "../models/NewsModel";
import PagedResponse from "../models/PagedResponse";

/**
 * Fetch news from api
 *
 * @param {string} protocol - protocol of the request, i.e. http:// or https://
 * @param {string} host - host of the request, i.e. loomissc.dev.local
 * @param {string} apiSuffix -  api suffix, i.e. /api/loomis/news
 * @param {string} folderId - folder id, i.e. {FF005073-5F75-488C-8242-3E83FFC239AA}
 * @param {string} categoryId - category id, i.e {58668B86-BCED-4CF1-811A-E5EF4B74A874}
 * @param {number} page - page to fetch
 * @param {number} perPage - how many per page
 * @param {string} listingPageId - listing page id, i.e. {3A50B6D2-56FD-4B4F-B6B9-41E7A646CD21}
 * @return {Object} json response
 */
const newsFetch = async (
  protocol,
  host,
  apiSuffix,
  folderId,
  categoryId,
  page,
  perPage,
  listingPageId
) => {
  let url = "";
  if (protocol && host && apiSuffix) {
    url = buildUrl(protocol, host, apiSuffix, [folderId, listingPageId], {
      categoryId,
      page,
      perPage,
    });
  } else {
    url = buildUrlLocation(
      [apiSuffix, folderId, listingPageId],
      {
        categoryId,
        page,
        perPage,
      },
      true
    );
  }

  const response = await fetchClient(url);
  if (response.success && response.data) {
    const pagedResponse = new PagedResponse(response.data);
    const news = [];
    if (!isEmpty(response.data.news) && Array.isArray(response.data.news)) {
      response.data.news.forEach((newsItem) =>
        news.push(new NewsModel(newsItem))
      );
      pagedResponse.setResults(news);
    }
    response.data = pagedResponse;
  }
  return response;
};

export default newsFetch;
